import React from "react";
import { Box} from "@mui/material";
import UploadImage from "./UploadImage";
import './Studio.css'

interface VideoComponentProps {
    image?: string | null;
    setImage?: (value: string | null) => void; 
    setUploadFile?: (value: any) => void; 
    uploadfile?: any; 
    prompt?: string;
    setPrompt?: (value: string) => void;
    setVideoData?: (value: any) => void;
    videoData?: any;
    setOpenPopover?: (value: boolean) => void | undefined;
    openPopover?: boolean;
}

export default function UploadImages({image, setImage, setUploadFile, uploadfile, prompt, setPrompt, setVideoData, videoData, setOpenPopover, openPopover}: VideoComponentProps) {
    // const [value, setValue] = React.useState(0);
    // const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    //     setValue(newValue);
    // };

    return (
        <div className="uploadContainer">
            <Box className="tabsContainer">
                <Box className="tabsHeader">
                    {/* <Tabs
                        value={value}
                        onChange={handleChange}
                        textColor="inherit"
                        indicatorColor="primary"
                        className="tabs"
                    >
                        <Tab label="From Image" className="tab" />
                        <Tab label="From Text" className="tab" />
                    </Tabs> */}
                </Box>
            </Box>

            {/* Conditional Rendering Based on Selected Tab */}
            <Box className="contentContainer">
            <UploadImage image={image} setImage={setImage} setUploadFile={setUploadFile} uploadfile={uploadfile} setPrompt={setPrompt} prompt={prompt} setVideoData={setVideoData} videoData={videoData} setOpenPopover={setOpenPopover} openPopover={openPopover}/>
            </Box>
        </div>
    );
}